'use strict'

/*
 * Module permettant la sélection d'une catégorie et l'affichage du panel correspondant.
 * Ce panel peut contenir des items, par exemple des tailles.
 */

const J_PANEL_SELECTOR = '.j_panelSelector'
const J_LIST_CATEGORY = '.j_listCategory'
const J_PANEL_ITEM = '.j_panelItem'
const J_BORDER_SELECTED = '.j_borderSelected'
const J_SELECTED_PANEL_DATA = 'selectedpanel'
const C_HIDDEN = 'hidden'
const C_SELECTED = 'active'

/*
 * Fonction de gestion du clique sur chacune des différentes icônes du genre
 * pour afficher les tailles correspondantes. Peut exécuter une callback si elle est différent de undefined
 */
function setEvents(callback) {
    $(J_PANEL_SELECTOR)
        .find(J_LIST_CATEGORY)
        .on('click', function (event) {
            setSelectedCategory(event.currentTarget)
            showPanel(event.currentTarget)
            if (callback !== undefined) {
                callback()
            }
        })
}

/*
 * D'abord on désélectionne toutes les catégories
 * puis on sélectionne celle qui nous intéresse
 */
function setSelectedCategory(currentTarget) {
    $(J_LIST_CATEGORY).prop('checked', false)
    $(J_BORDER_SELECTED).removeClass(C_SELECTED)
    $(currentTarget).prop('checked', true)
    $(currentTarget).parent().addClass(C_SELECTED)
}

/*
 * D'abord on cache les panels correspondant aux catégories
 * ensuite on affiche celui qui nous intéresse
 */
function showPanel(currentTarget) {
    const destination = $(currentTarget).data(J_SELECTED_PANEL_DATA)
    $(J_PANEL_ITEM).addClass(C_HIDDEN)
    $(destination).removeClass(C_HIDDEN)
}

export default {
    setEvents: setEvents,
    setSelectedCategory: setSelectedCategory,
    showPanel: showPanel
}
